export default function recommendationUniqueReferenceNumberDirective(
  $q,
  $timeout,
  amDataService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    $timeout(
      () => {
        const auditId = attributes.auditId || -1;
        const recommendationId = attributes.recommendationId || -1;

        ngModel.$asyncValidators.amRecommendationUniqueReferenceNumber = function (modelValue) {
          const defer = $q.defer();
          if (modelValue) {
            amDataService.checkRecommendationReferenceNumberExists(auditId, recommendationId, modelValue)
              .then((data) => {
                if (data && data.data.result === false) {
                  defer.resolve();
                } else {
                  defer.reject();
                }
              })
              .catch(defer.reject);
          } else {
            defer.resolve();
          }

          return defer.promise;
        };
      },
      0
    );
  }
}

export const name = 'amRecommendationUniqueReferenceNumber';

recommendationUniqueReferenceNumberDirective.$inject = [
  '$q',
  '$timeout',
  'amDataService'
];
